import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.abort = new AbortController()
    const options = { signal: this.abort.signal }
    this.hero = this.element.querySelector('.hero')
    this.object = this.element.querySelector('.hero-object')
    this.button = this.element.querySelector('.motion-button')
    this.canvas = this.element.querySelector('canvas')
    this.ctx = this.canvas.getContext('2d')
    this.media = matchMedia('(prefers-reduced-motion: reduce)')
    this.paused = this.media.matches
    this.visible = true
    this.frame = null
    this.tick = this.tick.bind(this)
    this.button.addEventListener('click', () => { this.paused = !this.paused; this.update() }, options)
    this.media.addEventListener('change', e => { this.paused = e.matches; this.update() }, options)
    window.addEventListener('resize', () => this.resize(), options)
    document.addEventListener('visibilitychange', () => this.update(), options)
    this.hero.addEventListener('pointermove', e => {
      if (this.paused || e.pointerType === 'touch') return
      const r = this.hero.getBoundingClientRect()
      this.object.style.transform = `translate(${(e.clientX-r.left-r.width/2)*.015}px,${(e.clientY-r.top-r.height/2)*.012}px)`
    }, options)
    this.hero.addEventListener('pointerleave', () => this.object.style.transform = '', options)
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update() })
    this.observer.observe(this.hero)
    this.reveals = [...document.querySelectorAll('.concept .reveal')]
    this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('ds-pending')
        this.revealObserver.unobserve(entry.target)
      }
    }), { threshold: .08 })
    if (!this.media.matches) this.reveals.forEach(el => {
      el.classList.add('ds-pending')
      this.revealObserver.observe(el)
    })
    document.addEventListener('turbo:before-cache', () => this.reveals.forEach(el => el.classList.remove('ds-pending')), options)
    this.resize()
    this.update()
  }
  disconnect() {
    this.abort.abort()
    this.observer.disconnect()
    this.revealObserver.disconnect()
    this.reveals.forEach(el => el.classList.remove('ds-pending'))
    cancelAnimationFrame(this.frame)
  }
  resize() {
    this.w = this.hero.clientWidth; this.h = this.hero.clientHeight
    const dpr = Math.min(devicePixelRatio || 1, 1.5)
    this.canvas.width = this.w*dpr; this.canvas.height = this.h*dpr
    this.ctx?.setTransform(dpr, 0, 0, dpr, 0, 0)
    this.draw(0)
  }
  update() {
    this.element.classList.toggle('motion-paused', this.paused)
    this.button.textContent = this.paused ? 'MOTION OFF ▷' : 'MOTION ON Ⅱ'
    this.button.setAttribute('aria-pressed', String(this.paused))
    this.button.setAttribute('aria-label', this.paused ? 'Play animation' : 'Pause animation')
    cancelAnimationFrame(this.frame)
    if (!this.paused && this.visible && !document.hidden) this.frame = requestAnimationFrame(this.tick)
    else this.object.style.transform = ''
  }
  tick(t) {
    if (!this.last || t-this.last > 40) { this.draw(t); this.last = t }
    this.frame = requestAnimationFrame(this.tick)
  }
  draw(t) {
    const c = this.ctx, w = this.w, h = this.h
    if (!c) return
    c.clearRect(0,0,w,h); c.strokeStyle = '#a0a78a'; c.lineWidth = .5
    const horizon = h*.62
    c.globalAlpha = .15
    for(let i=0;i<22;i++){const x=w*i/21;c.beginPath();c.moveTo(w*.68+(x-w*.5)*.2,horizon);c.lineTo(x*1.7-w*.35,h);c.stroke()}
    for(let j=0;j<11;j++){const q=(j/11+t*.000012)%1,y=horizon+q*q*(h-horizon);c.globalAlpha=q*.2;c.beginPath();c.moveTo(0,y);c.lineTo(w,y);c.stroke()}
    c.globalAlpha=.35;c.fillStyle='#c7cdb6'
    for(let k=0;k<35;k++) c.fillRect((k*137.51)%w,(k*91.17)%h,1,1)
    c.globalAlpha=1
  }
}
